var render = function render(){var _vm=this,_c=_vm._self._c;return _c('file-table',{attrs:{"foldName":'report3',"authority":'MisureReport'}})
}
var staticRenderFns = []

export { render, staticRenderFns }